import {createStore, compose, applyMiddleware} from "redux";
import { routerMiddleware } from "connected-react-router";
import { createHashHistory } from "history";
import thunkMiddleware from "redux-thunk";
import appReducers, {IReduxState} from "reducers";
import reduxRequestMiddleWare from "redux-request-middleware";
import { Middleware } from "redux";
export const history = createHashHistory({
    baseUrl: "/",
})
export default function configureStore(initialState) {
  // Add redux-devtools-extension plugin
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(
    appReducers(history),
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware,
        reduxRequestMiddleWare as Middleware,
        routerMiddleware(history),
      ),
    ),
  );
}
